<template>
  <div>
    <SubmitForm type="submit" />
  </div>
</template>

<script>
import SubmitForm from './components/SubmitForm.vue';
export default {
  components: {
    SubmitForm,
  },
  data() {
    return {};
  },
  created() {

  },
  methods: {

  },
};
</script>

<style lang="scss" scoped></style>